import { render, staticRenderFns } from "./RightChart.vue?vue&type=template&id=4567478a&"
import script from "./RightChart.vue?vue&type=script&lang=ts&"
export * from "./RightChart.vue?vue&type=script&lang=ts&"
import style0 from "./RightChart.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports